import * as Yup from "yup";

export const SetupFeeValidation = (
  formatWithCurrency: (value: number) => string,
  estimatedInvoiceAmount?: number,
) =>
  Yup.number()
    .nullable()
    .positive("Setup fee should be a positive number")
    .when("amount", ([amount], schema) => {
      if (!amount) {
        return schema;
      }

      return schema
        .lessThan(
          amount,
          `Setup fee can't be equal or larger to approved amount (${formatWithCurrency(amount)})`,
        )
        .typeError("Setup fee has to be a number")
        .integer(
          `Setup fee has to be indicated in amount - e.g. ${formatWithCurrency(5000)}`,
        )
        .min(0, `Setup fee can't be lower than ${formatWithCurrency(0)}`);
    })
    .when("purchasedAmountPercent", ([purchasedAmountPercent], schema) => {
      if (!purchasedAmountPercent || !estimatedInvoiceAmount) {
        return schema;
      }

      return schema.lessThan(
        (estimatedInvoiceAmount * purchasedAmountPercent) / 100,
        `Setup fee can't be equal or larger to approved amount (${formatWithCurrency(
          (estimatedInvoiceAmount * purchasedAmountPercent) / 100,
        )})`,
      );
    })
    .test(
      "setupFee-totalCost-check",
      "Setup fee should be included in calculation of total cost. Currently total cost is smaller than amount + setup fee.",
      function (value) {
        const { amount, totalCost } = this.parent;

        if (!value || !totalCost || amount == null) {
          return true; // Skip validation if any value is missing
        }

        return (totalCost as number) >= (amount as number) + value;
      },
    );
